import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
/* Automatically generated by './build/bin/build-entry.js' */
import Button from './components/button';
import ButtonGroup from './components/button-group';
import Icon from './components/icon';
import IconButton from './components/icon-button';
import Navbar from './components/navbar';
import NavbarSearch from './components/navbar-search';
import NavbarIconItem from './components/navbar-icon-item';
import NavbarItem from './components/navbar-item';
import Tabs from './components/tabs';
import TabPane from './components/tab-pane';
import TabDrop from './components/tab-drop';
import Pagination from './components/pagination';
import Badge from './components/badge';
import Radio from './components/radio';
import RadioButton from './components/radio-button';
import RadioGroup from './components/radio-group';
import Switch from './components/switch';
import Steps from './components/steps';
import Step from './components/step';
import Input from './components/input';
import Textarea from './components/textarea';
import Checkbox from './components/checkbox';
import CheckboxGroup from './components/checkbox-group';
import CollapseItem from './components/collapse-item';
import Collapse from './components/collapse';
import Progress from './components/progress';
import Announcement from './components/announcement';
import Notification from './components/notification';
import Message from './components/message';
import Tooltip from './components/tooltip';
import Tag from './components/tag';
import BreadcrumbItem from './components/breadcrumb-item';
import Breadcrumb from './components/breadcrumb';
import Popover from './components/popover';
import Modal from './components/modal';
import Confirm from './components/confirm';
import Select from './components/select';
import Option from './components/option';
import OptionGroup from './components/option-group';
import Slider from './components/slider';
import FormItem from './components/form-item';
import Form from './components/form';
import TableColumn from './components/table-column';
import Table from './components/table';
import DropdownMenuItem from './components/dropdown-menu-item';
import DropdownMenu from './components/dropdown-menu';
import Dropdown from './components/dropdown';
import DatePicker from './components/date-picker';
import TimePicker from './components/time-picker';
import Tree from './components/tree';
import TreeNode from './components/tree-node';
import List from './components/list';
import ListItem from './components/list-item';
import ListItemGroup from './components/list-item-group';
import Transfer from './components/transfer';
import TransferPanel from './components/transfer-panel';
import Upload from './components/upload';
import Timeline from './components/timeline';
import TimelineItem from './components/timeline-item';
import Sidebar from './components/sidebar';
import Loading from './components/loading';
import Autocomplete from './components/autocomplete';
import Header from './components/header';
import Aside from './components/aside';
import Main from './components/main';
import Footer from './components/footer';
import Container from './components/container';
import Row from './components/row';
import Col from './components/col';
import Rate from './components/rate';
import ColorPicker from './components/color-picker';
import Card from './components/card';
import InputNumber from './components/input-number';
import Cascader from './components/cascader';
import Affix from './components/affix';
import Anchor from './components/anchor';
import AnchorLink from './components/anchor-link';
import Drawer from './components/drawer';
import Menu from './components/menu';
import MenuItem from './components/menu-item';
import Submenu from './components/submenu';
import Carousel from './components/carousel';
import CarouselItem from './components/carousel-item';
import InputGroup from './components/input-group';
import Picker from './components/picker';
import Popconfirm from './components/popconfirm';
import ConfigProvider from './components/config-provider';
import CollapseTransition from './transitions/collapse-transition';
import { use as useLocal } from './locale';

var components = {
  Button: Button,
  ButtonGroup: ButtonGroup,
  Icon: Icon,
  IconButton: IconButton,
  Navbar: Navbar,
  NavbarSearch: NavbarSearch,
  NavbarIconItem: NavbarIconItem,
  NavbarItem: NavbarItem,
  Tabs: Tabs,
  TabPane: TabPane,
  TabDrop: TabDrop,
  Pagination: Pagination,
  Badge: Badge,
  Radio: Radio,
  RadioButton: RadioButton,
  RadioGroup: RadioGroup,
  Switch: Switch,
  Steps: Steps,
  Step: Step,
  Input: Input,
  Textarea: Textarea,
  Checkbox: Checkbox,
  CheckboxGroup: CheckboxGroup,
  CollapseItem: CollapseItem,
  Collapse: Collapse,
  Progress: Progress,
  Announcement: Announcement,
  Tooltip: Tooltip,
  Tag: Tag,
  BreadcrumbItem: BreadcrumbItem,
  Breadcrumb: Breadcrumb,
  Popover: Popover,
  Modal: Modal,
  Select: Select,
  Option: Option,
  OptionGroup: OptionGroup,
  Slider: Slider,
  FormItem: FormItem,
  Form: Form,
  TableColumn: TableColumn,
  Table: Table,
  DropdownMenuItem: DropdownMenuItem,
  DropdownMenu: DropdownMenu,
  Dropdown: Dropdown,
  DatePicker: DatePicker,
  TimePicker: TimePicker,
  Tree: Tree,
  TreeNode: TreeNode,
  List: List,
  ListItem: ListItem,
  ListItemGroup: ListItemGroup,
  Transfer: Transfer,
  TransferPanel: TransferPanel,
  Upload: Upload,
  Timeline: Timeline,
  TimelineItem: TimelineItem,
  Sidebar: Sidebar,
  Loading: Loading,
  Autocomplete: Autocomplete,
  Header: Header,
  Aside: Aside,
  Main: Main,
  Footer: Footer,
  Container: Container,
  Row: Row,
  Col: Col,
  Rate: Rate,
  ColorPicker: ColorPicker,
  Card: Card,
  InputNumber: InputNumber,
  Cascader: Cascader,
  Affix: Affix,
  Anchor: Anchor,
  AnchorLink: AnchorLink,
  Drawer: Drawer,
  Menu: Menu,
  MenuItem: MenuItem,
  Submenu: Submenu,
  Carousel: Carousel,
  CarouselItem: CarouselItem,
  InputGroup: InputGroup,
  Picker: Picker,
  Popconfirm: Popconfirm,
  ConfigProvider: ConfigProvider,
  CollapseTransition: CollapseTransition
};

export function install(Vue, options) {
  _Object$keys(components).map(function (name) {
    var component = components[name];
    Vue.component(component.name, component);
  });
  var $mtd = {
    confirm: Confirm,
    notify: Notification,
    message: Message
  };
  Vue.prototype.$mtd = $mtd;

  if (options && options.locale) {
    useLocal(options.locale);
  }
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { Button, ButtonGroup, Icon, IconButton, Navbar, NavbarSearch, NavbarIconItem, NavbarItem, Tabs, TabPane, TabDrop, Pagination, Badge, Radio, RadioButton, RadioGroup, Switch, Steps, Step, Input, Textarea, Checkbox, CheckboxGroup, CollapseItem, Collapse, Progress, Announcement, Notification, Message, Tooltip, Tag, BreadcrumbItem, Breadcrumb, Popover, Modal, Confirm, Select, Option, OptionGroup, Slider, FormItem, Form, TableColumn, Table, DropdownMenuItem, DropdownMenu, Dropdown, DatePicker, TimePicker, Tree, TreeNode, List, ListItem, ListItemGroup, Transfer, TransferPanel, Upload, Timeline, TimelineItem, Sidebar, Loading, Autocomplete, Header, Aside, Main, Footer, Container, Row, Col, Rate, ColorPicker, Card, InputNumber, Cascader, Affix, Anchor, AnchorLink, Drawer, Menu, MenuItem, Submenu, Carousel, CarouselItem, InputGroup, Picker, Popconfirm, ConfigProvider, CollapseTransition };

export default _extends({
  version: '0.4.16',
  install: install,
  locale: useLocal,
  Confirm: Confirm,
  Message: Message,
  Notification: Notification
}, components);